import React from "react";
import { useTranslation } from "react-i18next";

const WhatToBring = () => {
  const { t } = useTranslation();

  return (
    <section id="what-to-bring">
      <h2>{t("whatToBring.title")}</h2>
      <p>{t("whatToBring.intro")}</p>

      <h3>{t("whatToBring.listTitle")}</h3>
      <ul>
        {t("whatToBring.items", { returnObjects: true }).map(
          (item: string, idx: number) => (
            <li key={idx}>{item}</li>
          )
        )}
      </ul>

      <h3>{t("whatToBring.presentTitle")}</h3>
      <p>{t("whatToBring.presentText")}</p>
    </section>
  );
};

export default WhatToBring;
